import http from '../../core/services/http'

export const generateMenuAllergensReport = () =>
  http.get('/reports/menus-having-allergens', { responseType: 'blob' })
